import { render, staticRenderFns } from "./Folder_Form.vue?vue&type=template&id=22360058&scoped=true&"
import script from "./Folder_Form.vue?vue&type=script&lang=js&"
export * from "./Folder_Form.vue?vue&type=script&lang=js&"
import style0 from "./Folder_Form.vue?vue&type=style&index=0&id=22360058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22360058",
  null
  
)

export default component.exports